// extracted by mini-css-extract-plugin
module.exports = {"vGray14":"#7d85a4","tablet-landscape-up":"(min-width: calc(1024 * 1px))","desktop-up":"(min-width: calc(1280 * 1px))","nothing":"MessengerNothing_nothing__172k_"};